import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import BookingsApi from "../state/bookings-api";
import { bookingsStore, configStore } from "../state/CommonState";
import enqcountlogo from './enq-count.png'
import enq2quotelogo from './enq-to-quote.png'
import Utils from "../util/Utils";
import ChartApi from "./chart.api";
import { Chart } from "react-google-charts"

export default function ChartEnquiries(props) {
    useSnapshot(bookingsStore)
    useSnapshot(configStore)
    const [gaugeData, setGaugeData] = useState([
        ["Label", "Value"],
        ["Bookings", 0]
    ])
    const [enqSummary, setEnqSummary] = useState({
        totalEnquiries: 0,
        quotesSent: 0,
        averageTimeMillis: 0,
        enquiriesWithBookings: 0
    })
    const guageOptions = {
        width: 80,
        height: 80,
        minorTicks: 1,
        redFrom: 0,
        redTo: 30,
        yellowFrom: 30,
        yellowTo: 70,
        greenFrom: 70,
        greenTo: 100
    }

    useEffect(() => {
        let f = async () => {
            let ret = await ChartApi.getEnquirySummary()
            let percent = ret.totalEnquiries > 0 ?
                ret.enquiriesWithBookings / ret.totalEnquiries * 100 : 0
            percent = Math.round(percent)
            setGaugeData([
                ["Label", "Value"],
                ["Bookings", percent]])
            setEnqSummary(ret)
        }
        f()
    }, [configStore.currentSelectedEntity])

    return (
        <>
            <div className="columns" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="column is-4">
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#2d348c' }}>Generated</div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#2d348c' }}>Quote to Enquiry</div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#2d348c' }}>Booking Conversion</div>
                </div>
            </div>
            <div className="columns" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="column is-4">
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#000', marginTop: '0px' }}>
                        {enqSummary.totalEnquiries}
                    </div>
                </div>
                <div className="column is-4">
                    <div>
                        <img src={enq2quotelogo} width='64' height='64' style={{ paddingTop: '0px' }} />
                    </div>
                    <div style={{ color: '#119', fontWeight: 'bold', fontSize: '2rem' }}>
                        {Utils.millis2duration(enqSummary.averageTimeMillis).duration}
                    </div>
                </div>
                <div className="column is-4">
                    <div>
                        <Chart style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '0px' }}
                            chartType="Gauge"
                            data={gaugeData}
                            options={guageOptions}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}